// Notbremse um einen kompletten CRM-Aufruf — Lesen wie Schreiben.
//
// Der CRM-Client hat schon ein Zeitlimit pro HTTP-Anfrage (s. supabase.ts),
// das greift aber erst, WENN die Anfrage losgeschickt wurde. Davor liegt die
// Sitzungs-Sperre des Clients: alle Aufrufe warten hinter der Erneuerung des
// Anmelde-Tokens. Bleibt die hängen, wird nie ein Request abgeschickt — das
// HTTP-Zeitlimit kann also gar nicht auslösen, und der Aufruf steht endlos.
//
// Beim Laden war das abgedeckt (useCachedQuery), beim Speichern nicht: ein
// Klick auf „Speichern" wartete in diesem Fall stumm für immer. Von außen sieht
// das aus wie ein toter Knopf — genau so kam es aus dem Telefon-Team zurück.
//
// Bewusst größer als das HTTP-Limit (12 s), damit im Normalfall weiterhin die
// echte Fehlermeldung des Servers gewinnt und dieses Limit nur den Fall
// „Anfrage kam nie los" abfängt.
export const ZEITLIMIT_MS = 16_000;

export class ZeitlimitFehler extends Error {
  constructor() {
    super('Zeitüberschreitung — das CRM hat nicht geantwortet. Bitte einmal neu laden und erneut versuchen.');
    this.name = 'ZeitlimitFehler';
  }
}

// PromiseLike, nicht Promise: die Aufrufe des CRM-Clients sind Builder-Objekte,
// die erst beim `await` losgeschickt werden — sie sind thenable, aber kein Promise.
export function mitZeitlimit<T>(p: PromiseLike<T>, ms: number = ZEITLIMIT_MS): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new ZeitlimitFehler()), ms);
    p.then(
      (v) => { clearTimeout(timer); resolve(v); },
      (e) => { clearTimeout(timer); reject(e); },
    );
  });
}
